import React from 'react';

import {StethoscopeAvatar} from 'ccm/art/MedicalIcons';
import InfoCard from './InfoCard';

export default function PractitionersCard(props) {
    return (
        <InfoCard
            color='blue'
            Avatar={StethoscopeAvatar}
            title='Healthcare Providers'
            {...props}
        ></InfoCard>
    );
}
